// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageContainer,
  Title,
  DescriptionContainer,
  Description,
} from './Styles';
import { useLocation } from 'react-router-dom';

const SsoSignup = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const locationParams = new URLSearchParams(location.search);
  const programId = locationParams.get('programId')
  const customerId = locationParams.get('customerId')
  const error = locationParams.get('error')

  const renderContent = () => {
    if (error && error === '4903') {
      return (
        <>
          <Title>{t('notfound_error_title')}</Title>
          <DescriptionContainer>
            <Description>{t('sso_signup_already_registered')}</Description>
          </DescriptionContainer>
        </>)
    }
    if (programId && customerId && !error) {
      return (
        <>
          <Title>{t('sso_signup_codes')}</Title>
          <DescriptionContainer>
            <Description>{t('sso_signup_programid', { programId: programId })}</Description>
            <Description>{t('sso_signup_customerid', { customerId: customerId })}</Description>
          </DescriptionContainer>
        </>
      )
    }
    return (
      <>
        <Title>{t('notfound_error_title')}</Title>
        <DescriptionContainer>
          <Description>{t('sso_signup_contact_administrator')}</Description>
        </DescriptionContainer>
      </>
    )
  }

  return (
    <PageContainer>
      {renderContent()}
    </PageContainer>
  );
};

export default SsoSignup;
